import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { getRoomStatus, getFinalTeamAnswers } from "@bd-stores/game-progress";
import CompletionPopup from "@bd-utils/completion-popup";
import {
    saveFinalRoomAnswers,
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    getRoomAnswers,
} from "@bd-core/firebase-actions";

export class RoomCyclePuzzle extends BD_Component {
    constructor() {
        super();

        this.id = "cycle_puzzle";
        this.templateID = "cycle_puzzle-template";

        this.elms = {
            blur: ".app-blur",
            messageApp: "#messageApp",
            chatItem: ".js-chat-list",
            closeChat: "#closeMessage",
            codeInputPopup: ".js-code-popup",
            openCodeInput: ".js-open-code",
            closeCodeInput: ".js-close-code",
            inputAnswer: ".js-input-answer",
            checkAnswer: ".js-check-button",
            questionWrapper: ".js-question-wrapper",
            messageState: ".js-msg-state",
        };

        this._events = this.getEvents();

        (this.timeHour = 0), (this.timeMinute = 0);

        this.userAnswer = undefined;

        this.completionPopup = new CompletionPopup();
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.closeChat,
                handler: this.closeChat,
            },
            {
                event: "click",
                selector: elms.chatItem,
                handler: this.openChat,
            },
            {
                event: "click",
                selector: elms.openCodeInput,
                handler: this.toggleCodeInput,
            },
            {
                event: "click",
                selector: elms.closeCodeInput,
                handler: this.toggleCodeInput,
            },
            {
                event: "keypress",
                selector: elms.inputAnswer,
                handler: this.inputAnswer,
            },
            {
                event: "click",
                selector: elms.checkAnswer,
                handler: this.checkAnswer,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.startClock();
    }

    getModifiedData() {
        const modified = { ...this._data };

        const defaultImageBg = `${CONFIG.themeURL}/assets/images/bg-cycle-puzzle-new.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const _hints = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const _hotspots = this._data.hotspots
            .filter((h) => h["hotspot_type"] === "puzzle")
            .shift();

        const totalItem = this._data.items.length;

        const modifiedData = {
            ...modified,
            hints: _hints,
            hotspots: _hotspots,
            image_bg: _image_bg,
            total_item: totalItem,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        this._data.total_item = this._data.items.length;
        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        if (isForcedOpenChallenge) {
            this.onForceOppenChallenge();
        }
    }

    onForceOppenChallenge() {
        const elms = this.elms;
        const hasOpen = $(elms.codeInputPopup).hasClass("is-open");
        const isOpen = !hasOpen;

        $(elms.codeInputPopup).toggleClass("is-open", isOpen);
        $(elms.blur).toggleClass("is-blurred", isOpen);
        $(".timer").toggleClass("is-top", isOpen);
    }

    setGameState() {
        const elms = this.elms;
        const roomID = this.roomId;
        const roomAnswers = getFinalTeamAnswers(roomID);
        const thisRoomStatus = getRoomStatus(roomID);
        const $questionWrapper = $(elms.questionWrapper);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (thisRoomStatus == "is-status-completed") {
            const $codePopup = $(elms.codeInputPopup);

            $questionWrapper
                .removeClass("is-wrong incorrect")
                .addClass("is-completed is-correct");

            $codePopup.removeClass("is-wrong incorrect").addClass("is-correct");

            $(".app__page").addClass("is-room-completed");
            $(elms.checkAnswer).prop("disabled", true);
        }

        getRoomAnswers(roomID).then((data) => {
            this.updateUserChoicesList(data);
        });

        if (roomAnswers) {
            const answers =
                typeof roomAnswers === "string"
                    ? [...roomAnswers]
                    : roomAnswers;

            if (Object.keys(answers).length == 0) return;

            $.each(answers, (index, value) => {
                $questionWrapper
                    .find(elms.inputAnswer)
                    .eq(index)
                    .prop("readonly", true)
                    .val(value);
            });

            if (thisRoomStatus == "is-status-completed") {
                const $codePopup = $(elms.codeInputPopup);

                $questionWrapper
                    .removeClass("is-wrong incorrect")
                    .addClass("is-completed is-correct");

                $codePopup
                    .removeClass("is-wrong incorrect")
                    .addClass("is-correct");

                $(".app__page").addClass("is-room-completed");
                $(elms.checkAnswer).prop("disabled", true);

                /* Show completion popup */
                this.completionPopup.show(roomID, false, roomAnswers);
            }
        }
    }

    startClock() {
        let self = this;

        if (this.interval) {
            return false;
        }

        const timeSteps = this._data.time_steps;
        const minTime = this._data.min_time;
        const maxTime = this._data.max_time;

        self.timeHour = minTime;

        const updateTime = function (hour, minute) {
            const txthours = hour.toString().padStart(2, "0");
            const txtMinutes = minute.toString().padStart(2, "0");

            $("#timeHolder__time").text(`${txthours}:${txtMinutes}`);
        };

        updateTime(self.timeHour, self.timeMinute);

        this.interval = setInterval(() => {
            self.timeMinute += timeSteps;

            if (self.timeMinute >= 60) {
                const currentMinutes = Math.floor(self.timeMinute % 60);
                self.timeMinute = currentMinutes;

                self.timeHour++;

                if (self.timeHour == maxTime + 1) {
                    self.timeHour = minTime;
                }
            }

            updateTime(self.timeHour, self.timeMinute);
        }, 1000);
    }

    // ============================== CUSTOM FUNCTION

    closeChat() {
        $(this.elms.messageApp).removeClass("inMessage");
    }

    openChat(e, el) {
        const self = this;
        const $el = $(el);
        const elms = self.elms;
        const itemID = $el.attr("data-id");
        const $chatItem = $(`.chatItem[data-id="${itemID}"]`);
        const $stateImages = $chatItem
            .find(elms.messageState)
            .addClass("hidden")
            .css("display", "none");
        let $activeImage = $();

        $.each($stateImages, function (index, msg) {
            const $msg = $(msg);

            if (index == 0) $activeImage = $msg;

            const startTime = Number($msg.attr("data-start"));
            const endTime = Number($msg.attr("data-end"));
            const isActive = self.isActiveImageState(startTime, endTime);

            if (isActive) {
                $activeImage = $msg;
                return false;
            }
        });

        $chatItem.siblings().removeClass("active");
        $chatItem.addClass("active");
        $activeImage.removeClass("hidden").removeAttr("style");

        $("#messageUserName").text($activeImage.attr("data-title"));
        $(elms.messageApp).addClass("inMessage");
    }

    isActiveImageState(startTime, endTime) {
        let activeHours = [];

        for (let index = startTime; index <= endTime; index++) {
            if (startTime == 24) {
                startTime = 0;
            }

            activeHours.push(startTime);
            startTime++;
        }

        return $.inArray(this.timeHour, activeHours) !== -1 ? true : false;
    }

    inputAnswer(e, el) {
        e.preventDefault();

        const $el = $(el);
        const $questionWrapper = $el.parents(this.elms.questionWrapper);
        const $questionPopup = $el.parents(this.elms.codeInputPopup);

        if ($questionWrapper.hasClass("is-completed")) {
            return false;
        }

        const regex = new RegExp("^[a-zA-Z0-9]+$");
        const key = String.fromCharCode(!e.keyCode ? e.which : e.keyCode);
        if (!regex.test(key)) {
            this.toggleCheckButton();
            return false;
        }

        const value = String($el.val(e.key));
        const $current = $el.parent();
        const $nextInput = $current.next();

        if (value.trim() !== "" && $nextInput.length) {
            $nextInput.find("input").trigger("focus");
        }

        $questionWrapper.removeClass("incorrect");
        $questionPopup.removeClass("is-wrong");

        this.toggleCheckButton();
    }

    toggleCodeInput() {
        const elms = this.elms;
        const hasOpen = $(elms.codeInputPopup).hasClass("is-open");
        const isOpen = !hasOpen;

        $(elms.codeInputPopup).toggleClass("is-open", isOpen);
        $(elms.blur).toggleClass("is-blurred", isOpen);
        $(".timer").toggleClass("is-top", isOpen);
    }

    toggleCheckButton() {
        const $checkBtn = $(this.elms.checkAnswer);
        const $answers = $(this.elms.inputAnswer);
        let isAllFilled = true;

        $.each($answers, function (index, elAnswer) {
            const answer = String($(elAnswer).val());

            if (answer.trim() == "") {
                isAllFilled = false;
                return false;
            }
        });

        $checkBtn
            .prop("disabled", !isAllFilled)
            .toggleClass("valid", isAllFilled);
    }

    checkAnswer(e, el) {
        const elms = this.elms;
        const $el = $(el);

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        const $questionWrapper = $(elms.questionWrapper);
        const $codePopup = $(elms.codeInputPopup);
        const $answers = $(elms.inputAnswer);

        $el.addClass("is-loading").prop("disabled", true);
        $questionWrapper.removeClass("incorrect is-correct");

        const roomId = this.roomId;
        const roomAnswers = getRoomAnswerById(roomId);
        let roomStatus = "is-status-started";
        let isCorrect = false;
        let answerData = "";

        $.each($answers, function (index, answer) {
            const $answer = $(answer);
            answerData += $answer.val();
        });

        if (roomAnswers.code == answerData) isCorrect = true;

        if (isCorrect) {
            roomStatus = "is-status-completed";

            const onSuccess = () => {
                $questionWrapper.addClass("is-correct");
                $codePopup.addClass("is-correct");
                $(".app__page").addClass("is-room-completed");
                $el.removeClass("is-loading");
            };

            const onError = () => {};

            saveFinalRoomAnswers(roomId, answerData)
                .then(onSuccess)
                .catch(onError);
        } else {
            $questionWrapper.addClass("incorrect");
            $codePopup.addClass("is-wrong");
            $el.removeAttr("disabled").removeClass("is-loading");
        }

        this.updateUserAnswer(answerData);

        maybeUpdateRoomStatus(roomId, roomStatus);
    }

    updateUserAnswer(answerData) {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        updateRoomAnswer(roomId, {
            [currentPlayerId]: {
                user_id: currentPlayerId,
                choice: answerData,
            },
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const users = onlinePlayers.map((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "string") {
                    return;
                }

                const user = {
                    ...player,
                    answer: thisPlayerAnswer,
                };

                return user;
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }
}
